import AIBeautyChatDrop from 'ai/components/AIBeautyChatDrop/AIBeautyChatDrop';
import { withAIBeautyChatDropProps } from 'ai/viewModel/header/withAIBeautyChatDropProps';

export default withAIBeautyChatDropProps(AIBeautyChatDrop);
